import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useDeleteUser() {
  const { t } = useTranslation(['users', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { deleter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const deleteUser = async (userId: string): Promise<boolean> => {
    setLoading(true)

    try {
      await deleter(
        `${CONFIG.BOUNCE_API}/api/v1/accounts/${encodeURIComponent(userId)}`
      )
      setError(null)
      setSuccess(t('users:users.success.deleted'))

      return true
    } catch (caughtError) {
      console.log(caughtError)

      if (caughtError instanceof ApiError) {
        setError(getErrorMessage(caughtError.data))
      } else {
        setError(t('exceptions:unknown'))
      }

      return false
    } finally {
      setLoading(false)
    }
  }

  return { deleteUser, loading, success, error, resetState }
}
